import { SelectValueStyle } from 'elements/minute/sidebar/sidebarComponents/atomic/SelectValue/SelectValueStyle';
import _ from 'lodash';
import { useEffect, useState } from 'react';
import Select from 'react-select';
import styled from 'styled-components/macro';

export interface ISelectValue {
    label: string;
    value: string;
}

interface Props {
    options: ISelectValue[];
    selectedOptions?: ISelectValue[];
    onChange?: (values: ISelectValue[]) => void;
    placeholder?: string;
    maxMenuHeight?: number;
    className?: string;
}

export const SelectMultipleValues = (props: Props): JSX.Element => {
    const [selectedOption, setSelectedOption] = useState<ISelectValue[]>(props.selectedOptions);

    useEffect(() => {
        if (!_.isEqual(props.selectedOptions, selectedOption)) {
            setSelectedOption(props.selectedOptions ?? null);
        }
    }, [props.selectedOptions]);

    function update(newValues: readonly ISelectValue[]) {
        setSelectedOption([...newValues]);
        props.onChange?.([...newValues]);
    }

    return (
        <S_SelectMultipleValues className={props.className}>
            <Select
                value={selectedOption}
                onChange={update}
                options={props.options}
                styles={SelectValueStyle}
                isMulti={true}
                placeholder={props.placeholder ?? 'Select'}
                components={{
                    ClearIndicator: () => null
                }}
                maxMenuHeight={props.maxMenuHeight ?? null}
            />
        </S_SelectMultipleValues>
    );
};

const S_SelectMultipleValues = styled.div``;
